import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons'
import cx from 'classnames';
import LockedInputs from './locked-input';
import DownloadOptions from './download-options';
import PaidPrerelease from './paid_prerelease';
import '../style.scss'
// import ChatPayPerMessage from './paid-settings';
// import Radio from 'common/components/elements/inputs/radio';
// import ChatOptions from './chat-option';
import ChatOptions from './chat-option';
import Radio from 'common/components/elements/inputs/radio';

const AccessItem = ({
   isActive,
   data = {},
   onChange,
   inputName,
   hasCanceldPercentag,
   access,
   maxPrice,
   setError,
   isPriceError,
   onWrongPriceLength,
   priceValidation,
   isMedia,
   isDownloadPriceError,
   othersMembershipName,
   contentType,
   memberType,
   showPrerelease,
   showDownload,
   showNewStyles,
   isLimitError,
   checkVoiceLimitValidation,
   isDownloadDisabled,
   disabledDownloadTooltipText,
}) => {
   const chatOptionsProps = {
      data: access,
      inputName: inputName,
      maxPrice: maxPrice.price,
      onWrongPriceLength: onWrongPriceLength,
      priceValidation: priceValidation,
      isLimitError: isLimitError,
      checkVoiceLimitValidation: checkVoiceLimitValidation,
      setError: setError,
      isPriceError: isPriceError,
      onFocus: (type) => setError(type, false),
      onChange: (name, value) => {
         onChange(name, value)
      },
      memberType: memberType,
   }
   return (
      <div
         role='presentation'
         onClick={ () => {
            if(data.disabled) return;

            if('video' === contentType || 'photoset' === contentType){
               if('locked' === access.type && priceValidation(access.unlock_price) && !isActive){
                  setError('unlock', true);
                  return;
               }
               const typePrefix = `for_${ access.type }`;
               let donwloadPrice = access[`download_price_${ typePrefix }`];
               if(!donwloadPrice && access[`download_available_for_${ typePrefix }`] && !access[`download_is_free_for_${ typePrefix }`]){
                  donwloadPrice = 0;
               }
               if(('locked' === access.type || 'unlocked' === access.type) && priceValidation(donwloadPrice, false, true) && !isActive){
                  setError('download', true);
                  return;
               }
               if(showPrerelease) {
                  if('unlocked' === access.type && 0 === +access[`pre_release_price_for_${ access.type }`]){
                  } else {
                     let preReleasePriceValidation = priceValidation(access[`pre_release_price_for_${ access.type }`]);
                     if(('locked' === access.type || 'unlocked' === access.type) && preReleasePriceValidation && !isActive){
                        setError('unlock', true);
                        return;
                     }

                  }
               }
            }
            if('chat' === contentType) {
               if(!checkVoiceLimitValidation(access) && !isActive) {
                  setError('limit', true);
                  return;
               }
               if('payed' === access.type && (priceValidation(access.price_for_voice_message_for_payed) || priceValidation(access.price_for_photo_message_for_payed)) && !isActive){
                  setError('unlock', true);
                  return;
               }
            }
            if(!isActive) {
               onChange(null);
            }
         } }
         className={
            cx({
               'flex flex-col border-box bg-panel rounded-btn px-4 py-3 items-start': true,
               [`border-2 border-${ data.color }`]: isActive,
               'cursor-pointer': !isActive && !data.disabled,
               'opacity-50': data.disabled,
               // 'items-center': showNewStyles,
            })
         }
         data-tooltip-id={ data.disabled && data.disabledTooltipText ? 'ams-top-tooltip' : null }
         data-tooltip-content={ data.disabled && data.disabledTooltipText ? data.disabledTooltipText : null }
      >
         <div
            className={
               cx({
                  'flex justify-between w-full': true,
                  'mb-3': ['on', 'payed'].includes(access.type) && contentType === 'chat' && isActive,
               })
            }
         >
            <div className='flex flex-1 flex-col'>
               <div className='flex flex-col justify-center'>
                  <div className='flex items-center gap-3'>
                     <div
                        style={ {
                           minWidth: '24px',
                        } }
                        className={
                           cx({
                              'h-6 w-6 flex items-center justify-center rounded-full': true,
                              [`bg-${ data.color }-12`]: isActive,
                              'bg-secondary-dark': !isActive,
                           })
                        }
                     >
                        <Icon name={ data.icon } size='sm' color={ isActive ? data.color : 'secondary' } />
                     </div>
                     <span className={ cx({
                        'leading-tight text-major dark:text-major-dark font-medium leading-16px': true,
                     }) }>{data.text} {othersMembershipName ? othersMembershipName : ''}</span>
                  </div>
                  {
                     data.description &&
                     <div
                        className={
                           cx({
                              'flex flex-col  mt-1': true,
                              'ml-9': !(['on', 'payed'].includes(access.type) && contentType === 'chat' && isActive),
                           })
                        }
                     >
                        {
                           data.description && (
                              <span className='text-secondary panel-description font-normal'>{data.description}</span>
                           )
                        }

                     </div>
                  }
               </div>

               {
                  data.wthPrice  && isActive && (
                     <LockedInputs
                        access={ access }
                        onChange={ (name, value) => onChange(name, value) }
                        inputName={ inputName }
                        hasCanceldPercentag={ hasCanceldPercentag }
                        maxPrice={ maxPrice.price }
                        minPrice={ maxPrice.minPrice }
                        isPriceError={ isPriceError }
                        onWrongPriceLength={ onWrongPriceLength }
                        priceValidation={ priceValidation }
                        onFocus={ _ => setError('unlock', false) }
                        contentType={ contentType }
                     />
                  )
               }
               {
                  showDownload && !!isMedia && isActive && ('unlocked' === access.type || 'locked' === access.type) && 'live_stream' !== contentType && (
                     <DownloadOptions
                        onChange={ (name, value) => onChange(name, value) }
                        inputName={ `${ access.type }_${ inputName }` }
                        maxPrice={ maxPrice.download || maxPrice.price }
                        onWrongPriceLength={ onWrongPriceLength }
                        priceValidation={ priceValidation }
                        setError={ setError }
                        data={ access }
                        isDownloadPriceError={ isDownloadPriceError }
                        isDownloadDisabled={ isDownloadDisabled }
                        disabledDownloadTooltipText={ disabledDownloadTooltipText }
                     />
                  )
               }
               {
                  !!isMedia && isActive && ('unlocked' === access.type || 'locked' === access.type) && showPrerelease && 'live_stream' !== contentType && (
                     <PaidPrerelease
                        access={ access }
                        onChange={ (name, value) => onChange(name, value) }
                        inputName={ inputName }
                        hasCanceldPercentag={ hasCanceldPercentag }
                        maxPrice={ maxPrice.price }
                        isPriceError={ isPriceError }
                        onWrongPriceLength={ onWrongPriceLength }
                        priceValidation={ priceValidation }
                        onFocus={ _ => setError('unlock', false) }
                        setError={ setError }
                     />
                  )
               }
            </div>
            {
               isActive && (
                  // <div
                  //    style={ {
                  //       minWidth: '16px',
                  //    } }
                  //    className={ `h-4 w-4 flex items-center justify-center rounded-full bg-${ data.color }` }>
                  //    <Icon name='done' size='sm' color='major-dark' />
                  // </div>
                  <Radio
                     checked={ true }
                     onChange={ () => {} }
                     type={ 'radio' }
                  />
               )
            }
         </div>
         {
            ['on', 'payed'].includes(access.type) && contentType === 'chat' && isActive  && (
               // ['on', 'payed'].includes(access.type) && contentType === 'chat' && isActive  && (
               <div className='flex flex-col w-full gap-4'>
                  {
                     access.type === 'payed' && (
                        <ChatOptions
                           { ...chatOptionsProps }
                           type='text_message'
                           accessType='payed'
                        />
                     )
                  }
                  <ChatOptions
                     { ...chatOptionsProps }
                     type='photo_message'
                     accessType={ access.type === 'on' ? 'free' : 'payed' }
                  />
                  <ChatOptions
                     { ...chatOptionsProps }
                     type='voice_message'
                     accessType={ access.type === 'on' ? 'free' : 'payed' }
                  />
               </div>
            )
         }
      </div>

   )
}


AccessItem.propTypes = {
   isActive: PropTypes.bool,
   data: PropTypes.object,
   onChange: PropTypes.func,
   inputName: PropTypes.any,
   hasCanceldPercentag: PropTypes.bool,
   access: PropTypes.object,
   maxPrice: PropTypes.object,
   setError: PropTypes.func,
   isPriceError: PropTypes.bool,
   isDownloadPriceError: PropTypes.bool,
   onWrongPriceLength: PropTypes.func,
   priceValidation: PropTypes.func,
   isMedia: PropTypes.bool,
   othersMembershipName: PropTypes.string,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   isLimitError: PropTypes.bool,
   contentType: PropTypes.string,
   memberType: PropTypes.string,
   showNewStyles: PropTypes.bool,
   checkVoiceLimitValidation: PropTypes.func,
   isDownloadDisabled: PropTypes.bool,
   disabledDownloadTooltipText: PropTypes.string,
}

export default AccessItem
